document.addEventListener("DOMContentLoaded", () => {
    const banner = document.getElementById("cookie-consent");
    const acceptBtn = document.getElementById("cookie-accept");
    const declineBtn = document.getElementById("cookie-decline");
    if (!banner || !acceptBtn || !declineBtn) return;

    const COOKIE_KEY = "nexmoov_cookie_consent";
    const CONSENT_EVENT = "nexmoov:cookie-consent";

    const setOffsets = (height = 0) => {
        const px = `${height}px`;
        // iPhoneのホームバー考慮
        document.body.style.paddingBottom = height ? `calc(${px} + env(safe-area-inset-bottom, 0px))` : "";
        if (height) {
            document.documentElement.style.setProperty("--cookie-consent-height", px);
            document.documentElement.style.setProperty("--bt-offset", `${height + 12}px`); // バナー上に12px余白
        } else {
            document.documentElement.style.removeProperty("--cookie-consent-height");
            document.documentElement.style.removeProperty("--bt-offset");
        }
    };

    const syncOffsets = () => setOffsets(banner.offsetHeight || 0);

    const open = () => {
        banner.hidden = false;
        requestAnimationFrame(() => {
            banner.classList.add("is-active");
            syncOffsets();
        });
    };

    const close = (value) => {
        if (value) {
            localStorage.setItem(COOKIE_KEY, value);
            window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: { value } }));
        }
        banner.classList.remove("is-active");
        setTimeout(() => {
            banner.hidden = true;
            setOffsets(0);
        }, 320);
    };

    if (!localStorage.getItem(COOKIE_KEY)) open();
    acceptBtn.addEventListener("click", () => close("accepted"));
    declineBtn.addEventListener("click", () => close("declined"));

    // 画面回転・リサイズ時に再計算
    window.addEventListener("resize", () => {
        if (!banner.hidden && banner.classList.contains("is-active")) syncOffsets();
    });
});
